import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useUserBookingsRefundStatusCheckAPI = () => {
  const configuration = useConfiguration();
  const [payemtDetails, setPayemtDetails] = useState(null);
  const dispatch = useAppDispatch();

  const execute = useCallback(
    async (bookingId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: InventoryTaxCreateAPIResponse = await axios
          .get(`${BOOKING_APIS?.CHECK_REFUND_STATUS?.baseURL}?booking_id=${bookingId}` ?? "", {
            headers: {
              Authorization: `${accessToken}`,
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true && res.data) {
              setPayemtDetails(res.data.data);
              return { status: true, message: res.data.message };
            } else {
              setPayemtDetails(null);
              return { status: false, message: res.data.message };
            }
          })
          .catch((e: AxiosError) => {
            const err = e.response.data as any;
            setPayemtDetails(null);
            return { status: false, message: err.message };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return { status: false, message: "Bad Request" };
      }
    },
    [dispatch],
  );
  return { execute, payemtDetails };
};
